import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faClock, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { slideIn } from './AdminStyles';

// Styles des statistiques
const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
    margin-bottom: 2rem;
  }
`;

const StatCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #f3f4f6;
  transition: all 0.3s ease;
  animation: ${slideIn} 0.6s ease-out;
  animation-delay: var(--delay, 0s);
  animation-fill-mode: both;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const StatIcon = styled.div<{ $color: string }>`
  width: 60px;
  height: 60px;
  background: ${props => props.$color};
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const StatValue = styled.div`
  font-size: 2.5rem;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 0.5rem;
  letter-spacing: -0.025em;
`;

const StatLabel = styled.div`
  color: #6b7280;
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

interface Statistics {
  total: number;
  pending: number;
  confirmed: number;
  completed: number;
}

interface StatsCardsProps {
  stats: Statistics;
}

export function StatsCards({ stats }: StatsCardsProps) {
  return (
    <StatsGrid>
      <StatCard style={{ '--delay': '0.1s' } as React.CSSProperties}>
        <StatIcon $color="linear-gradient(135deg, #3b82f6, #2563eb)">
          <FontAwesomeIcon icon={faChartBar} />
        </StatIcon>
        <StatValue>{stats.total}</StatValue>
        <StatLabel>Total Réservations</StatLabel>
      </StatCard>
      
      <StatCard style={{ '--delay': '0.2s' } as React.CSSProperties}>
        <StatIcon $color="linear-gradient(135deg, #f59e0b, #d97706)">
          <FontAwesomeIcon icon={faClock} />
        </StatIcon>
        <StatValue>{stats.pending}</StatValue>
        <StatLabel>En Attente</StatLabel>
      </StatCard>
      
      <StatCard style={{ '--delay': '0.3s' } as React.CSSProperties}>
        <StatIcon $color="linear-gradient(135deg, #10b981, #059669)">
          <FontAwesomeIcon icon={faCheckCircle} />
        </StatIcon>
        <StatValue>{stats.confirmed}</StatValue>
        <StatLabel>Confirmées</StatLabel>
      </StatCard>
      
      <StatCard style={{ '--delay': '0.4s' } as React.CSSProperties}>
        <StatIcon $color="linear-gradient(135deg, #8b5cf6, #7c3aed)">
          <FontAwesomeIcon icon={faCheckCircle} />
        </StatIcon>
        <StatValue>{stats.completed}</StatValue>
        <StatLabel>Terminées</StatLabel>
      </StatCard>
    </StatsGrid>
  );
}
